import React, { useState, useEffect, useRef } from 'react';
import { Accordion, Card, Col, Row, Container, Button, Badge } from 'react-bootstrap';
import { motion } from 'framer-motion';
import {
  FaShippingFast,
  FaMoneyBillWave,
  FaBan,
  FaBoxOpen,
  FaQuestionCircle,
  FaHome,
  FaPhone,
  FaWhatsapp,
  FaClock,
  FaMapMarkerAlt
} from 'react-icons/fa';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Link } from 'react-router-dom';
import logo from '../assets/mboxLogo.jpeg';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

const position = [14.083986, -87.1855946]; 

function MapResize({ isVisible }) {
  const map = useMap();

  useEffect(() => {
    if (isVisible) {
      setTimeout(() => {
        map.invalidateSize();
      }, 200); 
    }
  }, [isVisible, map]);

  return null;
}

const FAQSection = () => {
  const [activeKey, setActiveKey] = useState(null);

  const faqItems = [
    {
      icon: <FaShippingFast className="text-primary me-2" />,
      title: "¿Cómo rotular tus paquetes?",
      body: (
        <>
          <Badge bg="warning" text="dark" className="mb-2 fw-normal">Aéreo</Badge>
          <ul className="mb-3">
            <li>Mbox Nº de casillero nombres y apellidos AE</li>
            <li>Dirección: 4789 NW 72ND AVE</li>
            <li>Teléfono: 13059342734</li>
            <li>Ciudad: Miami, Florida</li>
            <li>Código postal: 33166</li>
          </ul>
          <Badge bg="info" text="dark" className="mb-2 fw-normal">Marítimo</Badge>
          <ul>
            <li>Mbox Nº de casillero nombres y apellidos MR</li>
            <li>Dirección: 4789 NW 72ND AVE</li>
            <li>Teléfono: 13059342734</li>
            <li>Ciudad: Miami, Florida</li>
            <li>Código postal: 33166</li>
          </ul>
        </>
      ),
      tag: "Envíos"
    },
    {
      icon: <FaMoneyBillWave className="text-success me-2" />,
      title: "¿Cuáles son sus métodos de pago?",
      body: "Aceptamos pagos en efectivo, transferencias bancarias y pagos con tarjeta (débito o crédito) sin costo adicional.",
      tag: "Pagos"
    },
    {
      icon: <FaBan className="text-danger me-2" />,
      title: "¿Qué productos no puedes traer a Honduras?",
      body: "Artículos prohibidos como armas, explosivos, líquidos inflamables, perecederos o medicamentos sin receta.",
      tag: "Restricciones"
    },
    {
      icon: <FaBan className="text-danger me-2" />,
      title: "¿Qué productos no puedo enviar a Estados Unidos?",
      body: "Dinero, placas dentales, medicina natural sin registro, tabaco, alcohol, adornos frágiles, objetos cortopunzantes y aerosoles.",
      tag: "Restricciones"
    },
    {
      icon: <FaBoxOpen className="text-primary me-2" />,
      title: "¿Hacen entregas a domicilio?",
      body: "Sí, ofrecemos entrega a domicilio en Tegucigalpa y alrededores con costo adicional.",
      tag: "Servicios"
    },
    {
      icon: <FaMapMarkerAlt className="text-info me-2" />,
      title: "Ubicación de nuestra oficina",
      body: (
        <>
          <p className="mb-2">
            <strong>Dirección:</strong> Bulevar Centro América, Edificio Corporativo C.A L5 Piso 3, Tegucigalpa, Honduras
          </p>
          <div style={{ height: '250px', borderRadius: '8px', overflow: 'hidden' }} className="mt-3">
            <MapContainer
              center={position}
              zoom={17}
              style={{ height: '100%', width: '100%' }}
              scrollWheelZoom={false}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              <Marker position={position}>
                <Popup>
                  <strong>MBox Honduras</strong><br />
                  Edificio Corporativo C.A<br />
                  Bulevar Centro América<br />
                  Tegucigalpa
                </Popup>
              </Marker>
              <MapResize isVisible={activeKey === '5'} />
            </MapContainer>
          </div>
        </>
      ),
      tag: "Localización"
    }
  ];

  const contactInfo = [
    {
      icon: <FaPhone className="me-2" />,
      text: "+504 9874-4314",
      link: "tel:+50498744314"
    },
    {
      icon: <FaWhatsapp className="me-2" />,
      text: "WhatsApp: 9874-4314",
      link: "https://wa.me/50498744314"
    },
    {
      icon: <FaClock className="me-2" />,
      text: "Horario: Lunes-Viernes 8AM - 5PM, Sábado 8AM-12PM",
      link: null
    }
  ];

  return (
    <section
      className="py-4"
      style={{
        background: "linear-gradient(135deg, #182848 0%, #4b6cb7 100%)",
        color: "white",
        minHeight: "100vh"
      }}
    >
      <Container className="px-3" style={{ maxWidth: '800px' }}>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          {/* Header */}
          <Row className="mb-4 align-items-center justify-content-between">
            <Col xs="auto">
              <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
                <Link to="/" className="text-decoration-none">
                  <div className="d-flex align-items-center">
                    <img
                      src={logo}
                      alt="MBox Logo"
                      className="img-fluid me-2"
                      style={{ height: '40px', borderRadius: '6px' }}
                    />
                    <span className="text-white fw-bold d-none d-sm-inline">MBox Honduras</span>
                  </div>
                </Link>
              </motion.div>
            </Col>
            <Col xs="auto">
              <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
                <Link to="/" className="text-decoration-none">
                  <Button variant="outline-light" size="sm" className="d-flex align-items-center">
                    <FaHome className="me-1" />
                    <span>Inicio</span>
                  </Button>
                </Link>
              </motion.div>
            </Col>
          </Row>

          {/* Main Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            <Card className="border-0 shadow rounded-3 overflow-hidden mb-4"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)'
              }}
            >
              <div className="p-3 text-center"
                style={{
                  background: 'linear-gradient(90deg, rgba(0,100,200,0.3) 0%, rgba(0,150,255,0.4) 100%)',
                  borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
                }}
              >
                <motion.div 
                  whileHover={{ rotate: 10 }} 
                  transition={{ type: 'spring', stiffness: 300 }}
                  className="d-inline-block"
                >
                  <FaQuestionCircle size={36} className="mb-2 text-white" />
                </motion.div>
                <h2 className="fw-bold text-white mb-1">Preguntas Frecuentes</h2>
                <p className="mb-0 small text-white-80">Encuentra respuestas a las preguntas más comunes</p>
              </div>

              <Card.Body className="p-3 p-md-4">
                <Accordion
                  flush
                  activeKey={activeKey}
                  onSelect={(key) => setActiveKey(key)}
                >
                  {faqItems.map((item, index) => (
                    <motion.div
                      key={index}
                      whileHover={{ scale: 1.01 }}
                      whileTap={{ scale: 0.99 }}
                    >
                      <Accordion.Item
                        eventKey={index.toString()}
                        className="mb-2 border-0 rounded-2 overflow-hidden"
                        style={{
                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                        }}
                      >
                        <Accordion.Header className="py-2">
                          <div className="d-flex align-items-center w-100">
                            {item.icon}
                            <div className="d-flex justify-content-between w-100 align-items-center">
                              <span className="fw-semibold">{item.title}</span>
                              <Badge pill bg="light" text="dark" className="ms-2 fs-6">
                                {item.tag}
                              </Badge>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body className="text-white bg-dark bg-opacity-10">
                          {item.body}
                        </Accordion.Body>
                      </Accordion.Item>
                    </motion.div>
                  ))}
                </Accordion>
              </Card.Body>
            </Card>
          </motion.div>

          {/* Contact Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1, duration: 0.4 }}
          >
            <Card className="border-0 shadow rounded-3 overflow-hidden"
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                backdropFilter: 'blur(8px)'
              }}
            >
              <Card.Body className="p-3">
                <h5 className="fw-bold text-white mb-3">Contáctanos</h5>
                {contactInfo.map((contact, i) => (
                  <p key={i} className="mb-2 d-flex align-items-center text-white">
                    {contact.icon}
                    {contact.link ? (
                      <a
                        href={contact.link}
                        className="text-white text-decoration-none"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {contact.text}
                      </a>
                    ) : (
                      <span>{contact.text}</span>
                    )}
                  </p>
                ))}
              </Card.Body>
            </Card>
          </motion.div>
        </motion.div>
      </Container>
    </section>
  );
};

export default FAQSection;
